// extracted by mini-css-extract-plugin
export default {"payment_success_card":"OrderInfo_payment_success_card__7GZI5","payment_warning_card":"OrderInfo_payment_warning_card__KxLCC"};